"use strict";
import {http} from '../../../../core';
import Config from "../../../../app.config";
const RequestService = http.create();


export default {
    //问题细化统计
    //问题状态优先级紧急度统计
    problemStatus(params){
        return  RequestService.get('problem/problem_status_statistics',params)
    },
    //问题状态用户统计
    proStatusUser(params){
        return RequestService.post(`problem/problem_status_user_statistics?group=${params.group}&startTime=${params.startTime}&stopTime=${params.stopTime}`,params)
    },
    //问题状态用户按组统计
    proStausUserGroup(params){
        return RequestService.get('problem/problem_status_group_statistics',params)
    },
    //事件关闭分类统计
    eventCloseClassify(params){
        return RequestService.post(`event/event_close_classified_statistics?group=${params.group}&startTime=${params.startTime}&stopTime=${params.stopTime}`,params)
    },
    //事件关闭分类统计
    eventCloseClassifyGroup(params){
        return RequestService.get('event/event_close_classified_group_statistics',params)
    },

    //超出SLA的事件的数量
    getExceedSLA(params){
        return RequestService.get('event/event_sla_statistics',params)
    },
}
